import { render, staticRenderFns } from "./StudyActive.vue?vue&type=template&id=3c961ddd"
import script from "./StudyActive.vue?vue&type=script&lang=js"
export * from "./StudyActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports